module.exports = __webpack_public_path__ + "img/heart.63311ab6.svg";